import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { JobModels } from '@models/job.models';

@Injectable({ providedIn: 'root' })
export class JobManagerService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public getJobs(): Observable<JobModels.Document[]> {
    let params = new HttpParams();
    return this.http.get<JobModels.Document[]>(api.jobsManager.getJobs, { params });
  }
}